import type { BotStageType, BotQuestionOption } from "../Domain/FlexoBot";

export interface BotStageApi {
  question_uuid: string | null;
  type: BotStageType;
  user_uuid: string;
  uuid: string | null;
}

export interface BotStageAnswerApiCreationQuery {
  stage_uuid: string;
  value: string;
}

export enum BotQuestionTypeApi {
  MULTIPLE = "multiple",
  TEXT = "text",
}

export enum BotQuestionTextTypeApi {
  EMAIL = "email",
  PASSWORD = "password",
  PLAIN = "plain",
  PHONE = "phone",
}

export interface BotQuestionTextApi {
  type: BotQuestionTextTypeApi;
}

export interface BotQuestionApi {
  uuid: string;
  message: string;
  question_type: BotQuestionTypeApi;
  stage_uuid: string;
  options: BotQuestionOption[] | BotQuestionTextApi;
}
